<template>
    <div class="mt-5">
        <v-layout row>
            <v-flex md6>
                <h3>{{data.title}}</h3>
            </v-flex>
            <v-flex md6 class="text-md-right">

                <a
                  v-if = "data.export_url && tableData.length"
                  :href = "`${data.export_url}?${serializeQuery()}`"
                  class = "excel-btn"
                  target = "_blank">
                      Download Data
                </a>
            </v-flex>
        </v-layout>
        <v-layout row class="mt-3">
            <v-flex md12 class="text-md-right">
                <div class="d-inline-block ml-2" v-for="(item,index) in searcheable">
                    <v-text-field
                            v-model="filter[item]"
                            :placeholder="item.replace('_', ' ')"
                            solo
                    >
                    </v-text-field>
                </div>
                <div class="d-inline-block ml-2">
                    <v-btn color="primary" style="height: 50px" @click="getTableData" v-if="searcheable && searcheable.length" height="50" round>Filter</v-btn>
                </div>
            </v-flex>
        </v-layout>
        <v-data-table
          class="mt-2"
                :headers="headers"
                :items="tableData"
                :hide-actions="true"
                :loading = "isLoading"
                loading-text = "Loading... Please wait"

        >
            <template v-slot:items="props">
                <td class="text-xs-center" v-for="(value, key) in props.item" v-if="key !== 'inner_table'"  @click="openInnerTable(props.item.inner_table)">

                    <span v-if="get_field(key)">
                        <component :is="get_field(key).type" :value="value" :key-name="key" :id="props.item.id" @changeInput="updateData" />
                    </span>

                    <span v-else-if="key === 'Created at'" v-html="common.formatAMPM(value)">

                    </span>

                    <span v-else v-html="value ? value : '-' ">

                    </span>


                </td>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
            <v-pagination
              v-model="page"
              :length="pages"
              @input="getTableData($event, false)" />
        </div>
        <v-dialog v-model="dialog" width="1600" v-if="selectedInnerData && selectedInnerData.data_url">
            <v-card class="pa-5">
                <dynamic-table :data="selectedInnerData"/>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import common from '../../../utils/common'
    import recursiveTable from './recursive-table'
    import JsonExcel from 'vue-json-excel'
    import checkbox from './fields/check-box'
    export default {
        name: "dynamic-table",
        components: {
            JsonExcel,
            recursiveTable,
            checkbox
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data () {
            return {
                common,
                headers: [

                    // { text: 'Actions', value: 'name', sortable: false, align: 'center', }
                ],
                tableData: [],
                searcheable: [],
                filter: [],
                fields: [],
                page:1,
                pages:1,
                perPage: 5,
                isLoading: false,
                dialog: false,
                selectedInnerData: {}
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData (e, resetOffset = true) {
                this.isLoading = true
                if (resetOffset) this.page = 1
                console.log(this.filter)
                let filterQuery = common.serialize(this.filter)
                // if(filterQuery) {
                //     this.page = 1
                // }

                this.$http_noauth.get(`${this.data.data_url}?page=${this.page}&per_page=${this.perPage}&${filterQuery}`)
                    .then(response=>{
                        this.tableData =  response.data.data
                        this.searcheable = response.data.searcheable
                        this.pages = response.data.pages
                        this.fields = response.data.form_fields
                        this.formatTableHeader()
                        this.isLoading = false
                    })
                    .catch(error=>{
                        this.isLoading = false
                    })
            },
            serializeQuery(query = this.filter) {
                // const clone = { ...this.filter }
                return common.serialize(query)
            },
            formatTableHeader() {
                this.headers = []
                for (let property in this.tableData[0]) {
                    if (this.tableData[0].hasOwnProperty(property)) {
                        if (property !== 'inner_table') {
                            this.headers.push(
                              {
                                  text: property.replace("_", " "),
                                  align: 'center',
                                  sortable: false,
                                  value: property
                              },
                            )
                        }
                    }
                }
            },
            openInnerTable(data) {
                this.selectedInnerData = data
                this.dialog = true
            },
            get_field(key){
                if (this.fields) {
                    let field = this.fields.fields.find((item)=>{
                        return item.field === key
                    })
                    return field
                }
              return false
            },
            updateData(e) {
                this.$http_without_base.post(`${this.fields.url}`,e)

            }
        },
        watch: {
            data: {
                handler(val){
                   this.getTableData()
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss">
    .excel-btn {
        display: inline-block;
        width: auto;
        padding: 10px 19px;
        background: #4F47B6;
        color: white;
        border-radius: 5px;
        cursor: pointer;
    }


        ::placeholder {
            text-transform: capitalize;
        }
        :-ms-input-placeholder { /* Internet Explorer 10-11 */
            text-transform: capitalize;
        }

        ::-ms-input-placeholder { /* Microsoft Edge */
            text-transform: capitalize;
        }

    .theme--light.v-table thead th {
        text-transform: capitalize;
    }

</style>
